function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5265 0.120209C12.2764 0.00225222 11.6762 -0.0775238 11.4409 0.120255L4.77664 5.73523H1.43702C0.64522 5.73523 0 6.37334 0 7.1564V12.8411C0 13.6255 0.64522 14.2622 1.43702 14.2622H4.77664L11.4409 19.9468C11.5716 20.0492 12.2105 19.9723 12.2105 19.9723C12.2105 19.9723 12.4273 19.9227 12.5265 19.8758C12.7751 19.7579 12.9331 19.5092 12.9331 19.2363V0.761154C12.9331 0.488291 12.7751 0.239587 12.5265 0.120209Z",
  fill: "white"
});

function SvgIconMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuted);
export default __webpack_public_path__ + "static/media/icon-muted.aaca589f.svg";
export { ForwardRef as ReactComponent };